// frontend/src/features/content/Content.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import { useDeleteContentMutation, selectContentByIdForAdmin } from './contentApiSlice';
import { memo } from 'react';
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import useAuth from '../../hooks/useAuth';

const Content = ({ contentId, index }) => {
    const { isManager, isAdmin } = useAuth();
    const navigate = useNavigate();

    // Redux store से pagination/filter states प्राप्त करें
    const { pageNumber = 1, searchQuery = '', isActiveFilter = '', categoryFilter = '', ClanguageFilter = '' } = useSelector((state) => state.content);
    // queryArgs को मेमोराइज़ करने की आवश्यकता नहीं है क्योंकि यह selectContentByIdForAdmin को पास किया जा रहा है
    // और सिलेक्टर खुद कैश को ठीक से हैंडल करेगा।
    const queryArgs = { page: pageNumber, search: searchQuery, isActive: isActiveFilter, category: categoryFilter, Clanguage: ClanguageFilter }; // ✅ Clanguage added to queryArgs for selector

    // RTK Query कैश से विशिष्ट कंटेंट आइटम चुनें
    const contentItem = useSelector(state =>
        selectContentByIdForAdmin(state, queryArgs, contentId)
    );

    const [deleteContent, {
        isLoading: isDeleting,
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delError
    }] = useDeleteContentMutation();

    const handleEdit = () => navigate(`/dashboard/contents/${contentId}`);

    const onDeleteContentClicked = async () => {
        if (window.confirm("Are you sure you want to delete this content?")) {
            await deleteContent({ id: contentId });
        }
    };

    if (isDelSuccess) {
        // Deletion was successful, content will disappear from list
        // No need for separate UI updates here, RTK Query invalidatesTags handles it.
    }

    if (contentItem) {
        return (
            <>
                {/* DOM Nesting warning fix: Ensure no extra whitespace/newlines between <tr> and its immediate <td> children */}
                {/* Also, ensure all <td> tags are on the same line or properly indented without introducing text nodes */}
                <tr className="table__row">
                    <td className="table__cell">{index + 1}</td>
                    <td className="table__cell">{contentItem.title}</td>
                   
                    {/* ✅ New: Content Body Column */}
                    <td className="table__cell">
                        <div style={{ maxHeight: '60px', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
                            {contentItem.text_content ? contentItem.text_content.substring(0, 100) + (contentItem.text_content.length > 100 ? '...' : '') : '-'}
                        </div>
                    </td>
                    <td className="table__cell">{contentItem.category?.name || 'N/A'}</td>
                    <td className="table__cell">
                        {contentItem.media_url ? (
                            <img src={contentItem.media_url} alt="Content Thumbnail" style={{ width: '50px', height: 'auto' }} className="rounded" />
                        ) : (
                            'No Image'
                        )}
                    </td>
                    {/* ✅ New: Clanguage Column */}
                    <td className="table__cell">{contentItem.Clanguage ? (contentItem.Clanguage === 'hi' ? 'Hindi' : 'English') : '-'}</td>
                    <td className="table__cell">
                        {contentItem.isActive ? 'Yes' : 'No'}
                    </td>
                    <td className="table__cell">
                        <button
                            className="icon-button table__button me-2"
                            onClick={handleEdit}
                        >
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </button>
                        {(isManager || isAdmin) && (
                            <button
                                className="icon-button table__button text-danger"
                                onClick={onDeleteContentClicked}
                                disabled={isDeleting}
                            >
                                {isDeleting ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faTrashCan} />}
                            </button>
                        )}
                    </td>
                </tr>
                {isDelError && (
                    <tr>
                        {/* Ensure colSpan matches the total number of columns (9 in this case) */}
                        <td colSpan={9} className="text-center text-danger">
                            {delError?.data?.message || "Error deleting content."}
                        </td>
                    </tr>
                )}
            </>
        );
    } else {
        return null;
    }
};

const memoizedContent = memo(Content);

export default memoizedContent;